module.exports = __webpack_public_path__ + "img/photo_2.2e8ea2f6.jpg";